module.exports = "  					\
syntax = 'proto3';                      \
package e3;                             \
                                        \
message Animation {                     \
    required uint32 start = 1;          \
    required uint32 end = 2;            \
}                                       \
                                        \
message Commands {                      \
    required float hfov = 1;            \
    required float pitch = 2;           \
    required float roll = 3;            \
    required float yaw = 8;             \
    required uint32 scene = 4;          \
    required uint32 time = 5;           \
    required Animation animation = 9;   \
}                                       \
                                        \
message Properties {                    \
    required uint32 width = 1;          \
    required uint32 height = 2;         \
}                                       \
                                        \
message Coordinates {                   \
    required string id = 5;             \
    required string type = 6;           \
    required uint32 width = 1;          \
    required uint32 height = 2;         \
    required uint32 x = 3;              \
    required uint32 y = 4;              \
}                                       \
                                        \
message Textures {                      \
    required bytes image = 1;           \
    required Properties properties  = 2;\
    repeated Coordinates coordinates= 3;\
}                                       \
                                        \
message Play {                          \
    repeated Commands commands  = 2;    \
}";
